import { vnTemplate } from "../../../../valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export default class videoPickerView_template extends vnTemplate {
    private static readonly ONE_DAY = 86400000; //One day in milliseconds

    public parent: any;

    setParent(value: any) {
        this.parent = value;
    }

    protected getTemplateHtml(): string {
        return `<div class="w-img-picker-view" data-bind="css: { 'is-visible': videoPickerViewShown }">

                    <div class="img-picker-view">
                        <div class="view-header">
                            <strong data-bind="text: name"></strong>
                            <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                        </div>
                        <div class="view-body center">

                            <strong class="title" data-bind="text : title"></strong>
                            <div class="view-img-container">

                                <img data-bind="attr : { src : thumbnailUrl, width : 335, height : 188 }">
                            </div>

                            <div class="view-footer">

                                <div>
                                    <button class="btn-icon icon i-download" title="Download" type="button" data-bind="event: { click: onClickDownload }"><span>Download</span></button>
                                    <button class="btn-icon icon i-full-size" title="Preview" type="button" data-bind="event: { click: onClickPreviewVideo }"><span>Preview Video</span></button>
                                </div>
                                <div>
                                    <div class="insert-dropdown">
                                        <button class="btn-icon insert-dropdown-toggle i-dropdown-simple icon i-ins" type="button"><span>Insert</span></button>
                                        <div class="insert-dropdown-list">
                                            <button class="btn-icon icon i-ins-ind" type="button" data-bind="event: { click: onClickInsert.bind($parent, 'insert') }" title="Insert Individually"><span>Individually</span></button>
                                        </div>
                                    </div>

                                    <button class="btn-icon icon i-edit" title="Edit" type="button" data-bind="event: { click: onClickEdit }"><span>Edit</span></button>

                                </div>
                            </div>

                            <div class="w-view-info">

                                <dl class="view-info double-list">
                                    <dt><span>Duration</span></dt><dd><span data-bind="text: length"></span></dd>
                                    <dt><span>file size</span></dt><dd><span data-bind="text: readableVideoSize"></span></dd>
                                    <dt><span>dimension</span></dt><dd><span class="lower-case" data-bind="text: width()+ 'px' + ' x ' + height() + 'px'"></span></dd>
                                    <dt><span>ratio</span></dt><dd><span data-bind="text: ratio"></span></dd>
                                    <dt><span>mime</span></dt><dd><span data-bind="text: mimeType"></span></dd>
                                    <dt><span>Under Embargo</span></dt><dd><span data-bind="text: videoIsUnderEmbargo"></span></dd>
                                    <dt><span>Producer</span></dt><dd><span data-bind="text: producer"></span></dd>
                                    <dt><span>Content Type</span></dt><dd><span data-bind="text: contentType"></span></dd>
                                    <dt><span>Primary Category</span></dt><dd><span data-bind="text: primaryCategory"></span></dd>
                                    <dt><span>Categories</span></dt><dd><span data-bind="text: categories"></span></dd>
                                    <dt><span>Primary Tag</span></dt><dd><span data-bind="text: primaryTag"></span></dd>
                                    <dt><span>Tags</span></dt><dd><span data-bind="text: tags"></span></dd>
                                    <dt><span>Subtitles</span></dt><dd><span data-bind="text: subtitles"></span></dd>
                                </dl>

                                <div class="view-info">
                                    <h3 class="title" style="padding: 0; margin: 0 0 15px 0;">Description</h3>
                                    <!-- ko if: description -->
                                    <p data-bind="html: description"></p>
                                    <!-- /ko -->
                                    <!-- ko ifnot: description -->
                                    <p>None</p>
                                    <!-- /ko -->
                                </div>

                            </div>
                        </div>
                    </div>
                </div>`;
    }

    protected getTemplateName(): string {
        return "videoPickerView-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {
        let viewModel = {
            videoPickerViewShown: ko.observable(false),
            target: ko.observable(null),
            id: ko.observable(null),
            title: ko.observable(null),
            description: ko.observable(null),
            url: ko.observable(null),
            length: ko.observable(null),
            thumbnail: ko.observable(null),
            thumbnailUrl: ko.observable(null),
            size: ko.observable(null),
            mimeType: ko.observable(null),
            width: ko.observable(null),
            height: ko.observable(null),
            ratio: ko.observable(null),
            isUnderEmbargo: ko.observable(null),
            dateCreated: ko.observable(null),
            dateUpdated: ko.observable(null),
            producer: ko.observable({}),
            idProducer: ko.observable(null),
            tags: ko.observableArray([]),
            idPrimaryTag: ko.observable(null),
            primaryTag: ko.observable(null),
            categories: ko.observableArray([]),
            idPrimaryCategory: ko.observable(null),
            primaryCategory: ko.observable(null),
            contentType: ko.observableArray([]),
            subtitles: ko.observableArray(""),
            details : ko.observable(null),
            videoTags : ko.observableArray(null),
            videoCategories : ko.observableArray(null),
            videoSubtitles : ko.observableArray(null),
            onClickCancel: (data, event) => this.onClickCancel(),
            onClickPreviewVideo: (data, event) => this.onClickPreviewVideo(data),
            onClickInsert: (param, data, event) => this.onClickInsert(param, data),
            onClickEdit: (data, event) => this.onClickEdit(data),
            onClickDownload: (data, event) => this.onClickDownload(),
            onClickDelete: (data, event) => this.onClickDelete(data),
            videoIsOlderThan24Hours: (data, event) => this.videoIsOlderThan24Hours(data),
        };

        const readableVideoSize = ko.pureComputed(() => {
            if (viewModel.size() != null) {
                return this.formatBytes(viewModel.size());
            }
            return "";
        });

        const videoIsUnderEmbargo = ko.pureComputed(() => {
            return viewModel.isUnderEmbargo() ? "Yes" : "No";
        });

        return { ...viewModel, readableVideoSize, videoIsUnderEmbargo };
    }

    toggleModal() {
        this.getTemplateViewModel().videoPickerViewShown(!this.getTemplateViewModel().videoPickerViewShown());
    }

    show() {
        this.getTemplateViewModel().videoPickerViewShown(true);
    }

    hide() {
        this.getTemplateViewModel().videoPickerViewShown(false);
    }

    isShown() {
        return this.getTemplateViewModel().videoPickerViewShown() === true;
    }

    onClickCancel(): any {
        this.hide();
    }

    videoIsOlderThan24Hours(data): any {
        let now: any = new Date();
        let imageCreationDate: any = new Date(data.dateCreated());

        return now - imageCreationDate > videoPickerView_template.ONE_DAY;
    }

    onClickDelete(data): any {
        this.parent.deleteVideo(this.getVideo());
    }

    onClickDownload(): any {
        let url = this.getTemplateViewModel().url().split("?")[0];
        let extension = url.split(".").pop();
        let title = this.getTemplateViewModel().title();
        this.downloadFile(url, title, extension);
    }

    downloadFile(url, title, extension = "mp4"): any {
        fetch(url)
            .then((resp) => resp.blob())
            .then((file) => {
                const url = window.URL.createObjectURL(file);
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = url;
                a.download = title + "." + extension;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(() => console.log("video download failed!"));
    }

    onClickEdit(data): any {
        this.parent.editVideo(this.getVideo());
    }

    onClickInsert(param, data): any {
        let videoCardElement = this.parent.videoPickerEdit.getVideoCardElement();
        let target = this.parent.getTarget();
        if (videoCardElement) {
            this.caller.replaceOrUpdateVideoCardElement(videoCardElement, this.getVideo(), target);
            this.parent.videoPickerEdit.setVideoCardElement(null);
            this.parent.hide();
            return;
        }

        this.parent.insertVideo(param, this.getVideo());
        this.hide();
    }

    onClickPreviewVideo(data): any {
        window.open(data.url(), "_blank");
    }

    setVideoData({
        id,
        title,
        description,
        url,
        length,
        size,
        thumbnail,
        width,
        height,
        ratio,
        mimeType,
        isUnderEmbargo,
        dateCreated,
        dateUpdated,
        details = null,
        videoTags = [],
        videoCategories = [],
        videoSubtitles = []
    }) {

        this.getTemplateViewModel().details(details)

        let producer = details !== null && details.producer !== null ? details.producer : null;
        let producerFullName =
            producer !== null && producer.valnet_user !== null && producer.valnet_user.fullNameAndLogin !== null
                ? producer.valnet_user.fullNameAndLogin
                : null;
        let idPrimaryTag = details !== null && details.idPrimaryTag !== null ? details.idPrimaryTag : null;
        let primaryTag =
            details !== null && details.primaryTag !== null
                ? details.primaryTag.name + " " + details.primaryTag.formattedTagTypeAndDataset
                : null;
        let idPrimaryCategory =
            details !== null && details.idPrimaryCategory !== null ? details.idPrimaryCategory : null;
        let primaryCategory =
            details !== null && details.idPrimaryCategory !== null ? details.primaryCategory.name : null;
        let videoContentType = details !== null && details.contentType !== null ? details.contentType.name : null;

        let tags = [];
        this.getTemplateViewModel().videoTags(videoTags)
        if (videoTags) {
            videoTags.forEach((t) => {
                let tag = t.tag.name;
                if (t.tag.type != null) {
                    tag = tag + " (" + t.tag.type.name + ")";
                }
                tags.push(tag);
            });
        }

        let categories = [];
        this.getTemplateViewModel().videoCategories(videoCategories)
        if (videoCategories) {
            videoCategories.forEach((t) => {
                let category = t.category.name;
                categories.push(category);
            });
        }

        let subtitles = [];
        this.getTemplateViewModel().videoSubtitles(videoSubtitles)
        if (videoSubtitles) {
            videoSubtitles.forEach((t) => {
                subtitles.push(t.language.name + " (" + t.type + ")");
            });
        }

        this.getTemplateViewModel().subtitles("");

        this.getTemplateViewModel()
            .id(id)
            .title(title)
            .description(description)
            .url(url)
            .length(length)
            .thumbnail(thumbnail)
            .thumbnailUrl(thumbnail ? thumbnail.url : "/assets/images/replace-video.png")
            .size(size)
            .width(width)
            .height(height)
            .ratio(ratio)
            .mimeType(mimeType)
            .isUnderEmbargo(isUnderEmbargo)
            .dateCreated(dateCreated)
            .dateUpdated(dateUpdated)
            .producer(producerFullName)
            .idPrimaryTag(idPrimaryTag)
            .primaryTag(primaryTag)
            .tags(tags.join(", "))
            .idPrimaryCategory(idPrimaryCategory)
            .primaryCategory(primaryCategory)
            .categories(categories.join(", "))
            .contentType(videoContentType)
            .subtitles(subtitles.join(", "));
    }

    clearData() {
        this.getTemplateViewModel()
            .id(null)
            .title(null)
            .description(null)
            .url(null)
            .length(null)
            .thumbnail(null)
            .thumbnailUrl(null)
            .size(null)
            .width(null)
            .height(null)
            .ratio(null)
            .mimeType(null)
            .isUnderEmbargo(null)
            .dateCreated(null)
            .dateUpdated(null)
            .producer(null)
            .idPrimaryTag(null)
            .primaryTag(null)
            .tags(null)
            .idPrimaryCategory(null)
            .primaryCategory(null)
            .categories(null)
            .contentType(null)
            .subtitles(null);
    }
    //TODO : pass the same data structure from view to edit
    getVideo() {
        const vm = this.getTemplateViewModel();
        const video = {
            id: vm.id(),
            title: vm.title(),
            description: vm.description(),
            url: vm.url(),
            length: vm.length(),
            thumbnail: vm.thumbnail(),
            size: vm.size(),
            width: vm.width(),
            height: vm.height(),
            ratio: vm.ratio(),
            mimeType: vm.mimeType(),
            isUnderEmbargo: vm.isUnderEmbargo(),
            dateCreated: vm.dateCreated(),
            dateUpdated: vm.dateUpdated(),
            producer: vm.producer(),
            idPrimaryTag: vm.idPrimaryTag(),
            primaryTag: vm.primaryTag(),
            tags: vm.tags(),
            idPrimaryCategory: vm.idPrimaryCategory(),
            primaryCategory: vm.primaryCategory(),
            contentType: vm.contentType(),
            subtitles: vm.subtitles(),
            details: vm.details(),
            videoTags: vm.videoTags(),
            videoCategories: vm.videoCategories(),
            videoSubtitles: vm.videoSubtitles()
        };
        return video;
    }

    formatBytes(bytes, decimals = 2) {
        if (!+bytes) return "0 Bytes";

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    }

    public setSubtitles(subtitles): void {
        this.getTemplateViewModel().subtitles(subtitles);
    }
}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/components/templates/videoPickerView_template.ts